import { Box, Flex } from '@chakra-ui/react';
import { BrandColor } from 'modules/User';

const square = '48px';
const MAX_COLORS = 5;

/**
 * Split the brand color into multiple peaces of 5
 * @param brandColors BrandColor
 * @param chunkSize number
 * @returns array
 */
function sliceIntoChunks(brandColors: BrandColor[], chunkSize: number) {
  const res = [];
  for (let i = 0; i < brandColors.length; i += chunkSize) {
    const chunk = brandColors.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}

interface PaletteViewProps {
  palettes: BrandColor[];
}

export const PaletteView = ({ palettes }: PaletteViewProps) => {
  return (
    <Flex borderRadius='md' overflow='hidden' border='1px' borderColor='gray.100' w='fit-content'>
      {palettes.map((palette, key) => (
        <Box key={key} width={square} height={square} background={palette.color} />
      ))}
    </Flex>
  );
};

const Palette = ({ palettes }: PaletteViewProps) => {
  if (palettes.length > MAX_COLORS) {
    const fixedPalettes: BrandColor[][] = sliceIntoChunks(palettes, 5);

    return (
      <Flex flexDirection='column' gap='12px'>
        {fixedPalettes.map((palette, key) => {
          return <PaletteView key={key} palettes={palette} />;
        })}
      </Flex>
    );
  }

  return <PaletteView palettes={palettes} />;
};

export default Palette;
